import { CElementType, IElementType } from '@ts/ui-models';
import { getElementType } from '@services/DataBase/ElementType.service';
import { createUseFetchByIdHook } from './useFetchByIdFactory';

//@ts-ignore
const useFetchElementType = createUseFetchByIdHook<IElementType, CElementType>({
    selector: state => state.global.elementsTypesList,
    key: 'elementsTypesList',
    fetchFn: (dispatch, ids) => getElementType(dispatch, ids),
    mapToClass: (model) => new CElementType(model),
});

export default useFetchElementType